module.exports = __webpack_public_path__ + "fonts/Rubik-Black.3aba47ab.ttf";